import * as Types from 'features/frontoffice/actions/types';
import axios from 'axios';
import { AppConfig } from 'AppConfig';

export const fetchExclusiveReports = () => {
  return (dispatch) => {
    dispatch({ type: Types.FETCH_REPORT_EXCLUSIVE_REQUEST });
    axios
      .get(AppConfig.FO_INITIAL_URL + `/report/exclusive`)
      .then((m) => {
        const response = m.data;
        dispatch({
          type: Types.FETCH_REPORT_EXCLUSIVE_SUCCESS,
          payload: response || null
        });
      })
      .catch(() => {
        dispatch({ type: Types.FETCH_REPORT_EXCLUSIVE_FAILURE });
      });
  };
};
